import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useMediaQuery } from 'react-responsive';

import TradeCard from './TradeCard';
import SaleEventHeader from '../../SaleEvent/SaleEventHeader';
import SaleEventFooter from '../../SaleEvent/SaleEventFooter';
import {
  GridCardPositionMapping,
  GridCardVariant,
  GridRowSize,
  ListVariant
} from '../../../_shared/types/trade';

const GridTradeCard = props => {
  const { type, positionIndex, tradeSummary } = props;
  const themeContext = useContext(ThemeContext);
  const isLargeScreen = useMediaQuery({
    query: `(min-width: ${themeContext.BP.GRIDVIEW_DESKTOP_WH})`
  });
  const rowSize = isLargeScreen ? GridRowSize.LARGE : GridRowSize.SMALL;
  const position = GridCardPositionMapping[positionIndex % rowSize];

  if (type === GridCardVariant.EVENT_START) {
    return (
      <SaleEventHeader
        {...props}
        listVariant={ListVariant.GRID}
        position={position}
      />
    );
  }
  if (type === GridCardVariant.EVENT_END) {
    return (
      <SaleEventFooter
        {...props}
        listVariant={ListVariant.GRID}
        saleEventId={tradeSummary?.saleEventId}
        position={position}
      />
    );
  }
  return <TradeCard {...props} position={position} />;
};

export default GridTradeCard;
